/* SOULSHAE — theme.js */
(function () {
  'use strict';

  /* ─── Helpers ─────────────────────────────────────────────────── */
  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const moneyFormat = (window.theme && window.theme.moneyFormat) || '€{{amount}}';

  function formatMoney(cents, fmt) {
  const f = fmt || moneyFormat;
  const m = f.match(/{{\s*(\w+)\s*}}/);
  if (!m) return f;
  const value = cents / 100;
  function group(num, dec, thouSep, decSep) {
    const parts = num.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return dec ? parts[0] + decSep + parts[1] : parts[0];
  }
  let out;
  switch (m[1]) {
    case 'amount_with_comma_separator':             out = group(value, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': out = group(value, 0, '.', ','); break;
    case 'amount_no_decimals':                      out = group(value, 0, ',', '.'); break;
    default:                                        out = group(value, 2, ',', '.');
  }
  return f.replace(m[0], out);
}
window.theme = window.theme || {};
window.theme.formatMoney = formatMoney;

  function on(el, evt, fn) {
    if (!el) return;
    el.addEventListener(evt, fn);
  }

  /* ─── Mobile menu ─────────────────────────────────────────────── */
  const mobileMenu = $('#mobile-menu');
  const mobileToggle = $('[data-mobile-toggle]');
  const mobileClose = $('[data-mobile-close]');

  function openMobileMenu()  { if (mobileMenu) mobileMenu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeMobileMenu() { if (mobileMenu) mobileMenu.classList.remove('is-open'); document.body.style.overflow = ''; }

  on(mobileToggle, 'click', openMobileMenu);
  on(mobileClose, 'click', closeMobileMenu);

  /* ─── Cart drawer ─────────────────────────────────────────────── */
  const cartDrawer  = $('#cart-drawer');
  const cartOverlay = $('#cart-drawer-overlay');
  const cartOpenBtns  = $$('[data-cart-open]');
  const cartCloseBtns = $$('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    refreshCart().finally(() => {
      cartDrawer.classList.add('is-open');
      if (cartOverlay) cartOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartOpenBtns.forEach(b => on(b, 'click', (e) => { e.preventDefault(); openCart(); }));
  cartCloseBtns.forEach(b => on(b, 'click', closeCart));
  on(cartOverlay, 'click', closeCart);

  on(document, 'keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeMobileMenu(); }
  });

  /* ─── Cart fetch + render ─────────────────────────────────────── */
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(renderCartDrawer)
      .catch(err => console.warn('[cart] fetch failed', err));
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = '(' + count + ')';
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer) return;
    const body  = $('[data-cart-body]', cartDrawer);
    const total = $('[data-cart-total]', cartDrawer);
    const cta   = $('[data-cart-checkout]', cartDrawer);

    updateCartCount(cart.item_count);

    if (cart.item_count === 0) {
      if (body) body.innerHTML = '<div class="cart__empty" style="padding:48px 0;">Your bag is quiet for now.</div>';
      if (total) total.textContent = '';
      if (cta) cta.style.display = 'none';
      return;
    }

    if (cta) cta.style.display = '';

    if (body) {
      body.innerHTML = cart.items.map(item => `
        <div class="cart__item" data-line="${item.key}">
          <div class="cart__item-media">
            ${item.featured_image && item.featured_image.url ? `<img src="${item.featured_image.url}" alt="${item.product_title}">` : ''}
          </div>
          <div>
            <div class="cart__item-title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart__item-variant">${item.variant_title}</div>` : ''}
            <div class="cart__qty" style="margin-top:10px;">
              <button class="cart__qty-btn" data-line-change="${item.key}" data-direction="-1">−</button>
              <input class="cart__qty-input" type="text" value="${item.quantity}" readonly>
              <button class="cart__qty-btn" data-line-change="${item.key}" data-direction="1">+</button>
            </div>
            <button class="cart__remove" data-line-remove="${item.key}">Remove</button>
          </div>
          <div class="cart__item-price">${formatMoney(item.final_line_price)}</div>
        </div>
      `).join('');
    }

    if (total) total.textContent = formatMoney(cart.total_price);

    // Attach handlers
    $$('[data-line-change]', body).forEach(btn => {
      on(btn, 'click', () => {
        const key = btn.getAttribute('data-line-change');
        const dir = parseInt(btn.getAttribute('data-direction'), 10);
        changeQuantity(key, dir);
      });
    });
    $$('[data-line-remove]', body).forEach(btn => {
      on(btn, 'click', () => {
        const key = btn.getAttribute('data-line-remove');
        updateQuantity(key, 0);
      });
    });
  }

  function changeQuantity(key, direction) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = Math.max(0, item.quantity + direction);
        return updateQuantity(key, newQty);
      });
  }

  function updateQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(r => r.json())
      .then(renderCartDrawer);
  }

  /* ─── Add to cart form ────────────────────────────────────────── */
  $$('form.product-form').forEach(form => {
    on(form, 'submit', (e) => {
      e.preventDefault();
      const submitBtn = $('[type="submit"]', form);
      if (submitBtn) submitBtn.disabled = true;

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(r => r.json())
        .then(() => {
          openCart();
        })
        .catch(err => {
          console.error('[add-to-cart]', err);
          alert('Could not add to bag. Please try again.');
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });

  /* ─── Product page — variant selection ────────────────────────── */
  $$('form.product-form').forEach(form => {
    const variantData = window.productVariants || [];
    const optionGroups = $$('[data-option-group]', form);
    const priceEl = $('[data-product-price]');
    const variantIdInput = $('[name="id"]', form);
    const submitBtn = $('[data-add-to-cart-btn]', form);

    function readSelected() {
      return optionGroups.map(group => {
        const selected = $('.is-selected', group);
        return selected ? selected.getAttribute('data-value') : null;
      });
    }

    function updateState() {
      const selected = readSelected();
      if (selected.some(v => v === null)) return;
      const match = variantData.find(v => {
        return v.options.every((opt, i) => opt === selected[i]);
      });
      if (!match) return;
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceEl.classList.add('product__price--sale');
          priceEl.innerHTML = `<span class="price--regular">${formatMoney(match.compare_at_price)}</span><span class="price--sale">${formatMoney(match.price)}</span>`;
        } else {
          priceEl.classList.remove('product__price--sale');
          priceEl.textContent = formatMoney(match.price);
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? (submitBtn.getAttribute('data-add-label') || 'Add to bag') : (submitBtn.getAttribute('data-sold-out-label') || 'Sold out');
      }
    }

    optionGroups.forEach(group => {
      $$('[data-value]', group).forEach(btn => {
        on(btn, 'click', () => {
          $$('[data-value]', group).forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          updateState();
        });
      });
    });
  });

  /* ─── Init ────────────────────────────────────────────────────── */
  refreshCart();
})();
